"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateTimeTrackingFieldValue = exports.getTimeTrackingFieldEmptyValue = void 0;
const getTimeTrackingFieldEmptyValue = () => {
    return { total_duration: 0, time_track_logs: [] };
};
exports.getTimeTrackingFieldEmptyValue = getTimeTrackingFieldEmptyValue;
const generateTimeTrackingFieldValue = (value) => {
    return { ...(0, exports.getTimeTrackingFieldEmptyValue)(), ...value };
};
exports.generateTimeTrackingFieldValue = generateTimeTrackingFieldValue;
